import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloads only lazy routes explicitly flagged with `data: { preload: true }`.
 * Used so the login / forgot-password chunks (and their component styles) are
 * ready in the background, avoiding the brief unstyled flash when navigating
 * to a lazy-loaded login screen. Does not activate routes or run guards.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data && route.data['preload'] ? load() : of(null);
  }
}
